// 统计
import * as activity from 'activityConfigES';

export const init = function () {
  activity.stat();
};
